module.exports = __webpack_public_path__ + "static/media/img2.c7194579.jpeg";